import { AuthPersistence } from '../../api/auth';

export function accountAuthPersistence(
  accountId: number,
  environment: string,
): AuthPersistence {
  if (environment == 'prod') {
    switch (accountId) {
      case 766: //[RIVET] Ops test for RIVET-8411 SOC 2
        return AuthPersistence.SESSION;
    }
  }
  return AuthPersistence.PERSISTENT;
}
